import { Select, styled } from '@mui/material';

export const StyledSortSelect = styled(Select)(({ theme }) => ({
	'& .MuiSelect-select': {
		fontSize: '14px',
		paddingBlock: '0px',
		[theme.breakpoints.down('xs')]: {
			paddingRight: '21px !important',
		},
	},
}));

export const StyledSortTitle = styled('p')(({ theme }) => ({
	fontSize: '14px',
	margin: 0,

	[theme.breakpoints.down('xs')]: {
		display: 'none',
	},
}));
